<template>
  <v-container>
    <v-row justify="center">
      <h1 v-if="internal" class="mb-5">
        Choose your plan:
      </h1>
      <h2 v-else class="mb-5">
        Compare our plans:
      </h2>
    </v-row>
    <v-row justify="center">
      <table class="pricing-table">
        <tr>
          <th></th>
          <th>
            <div class="pricing-table-title">
              FREE
              <span class="price">
                $0
              </span>
            </div>
            <v-btn
              v-if="internal && subscription === 'free'"
              disabled
              color="primary"
            >
              Current
            </v-btn>
            <v-btn
              v-else-if="
                internal &&
                  subscription !== '' &&
                  subscription.indexOf('commercial_custom_') < 0
              "
              color="primary"
              @click="showCancel = true"
            >
              Select
            </v-btn>
            <v-btn
              v-else-if="
                internal && subscription.indexOf('commercial_custom_') < 0
              "
              color="primary"
              @click="cancel"
            >
              Select
            </v-btn>
            <v-btn v-else-if="!internal" color="primary" @click="signup">
              Sign up
            </v-btn>
          </th>
          <th>
            <div>
              BASIC
            </div>
            <span class="price">$4.99&nbsp;<span>/mo</span> </span>
            <v-btn
              v-if="internal && subscription === 'basic'"
              disabled
              color="primary"
            >
              Current
            </v-btn>
            <v-btn
              v-else-if="
                internal && subscription.indexOf('commercial_custom_') < 0
              "
              :to="{ name: 'update-plan', params: { plan: 'basic' } }"
              color="primary"
            >
              Select
            </v-btn>
            <v-btn v-else-if="!internal" color="primary" @click="signup">
              Sign up
            </v-btn>
          </th>
          <th>
            <div>
              ENTHUSIAST
            </div>
            <span class="price">$9.99&nbsp;<span>/mo</span> </span>
            <v-btn
              v-if="internal && subscription === 'professional'"
              disabled
              color="primary"
            >
              Current
            </v-btn>
            <v-btn
              v-else-if="
                internal && subscription.indexOf('commercial_custom_') < 0
              "
              :to="{ name: 'update-plan', params: { plan: 'professional' } }"
              color="primary"
            >
              Select
            </v-btn>
            <v-btn v-else-if="!internal" color="primary" @click="signup">
              Sign up
            </v-btn>
          </th>
          <th>
            <div>
              COMMERCIAL INDIVIDUAL
            </div>
            <span class="price">$99&nbsp;<span>/mo</span> </span>
            <v-btn
              v-if="internal && subscription === 'commercial_individual'"
              disabled
              color="primary"
            >
              Current
            </v-btn>
            <v-btn
              v-else-if="
                internal && subscription.indexOf('commercial_custom_') < 0
              "
              :to="{
                name: 'update-plan',
                params: { plan: 'commercial_individual' }
              }"
              color="primary"
            >
              Select
            </v-btn>
            <v-btn v-else-if="!internal" color="primary" @click="signup">
              Sign up
            </v-btn>
          </th>
          <th>
            <div>
              COMMERCIAL SHARED
            </div>
            <span class="price">$249&nbsp;<span>/mo</span> </span>
            <v-btn
              v-if="internal && subscription === 'commercial_shared'"
              disabled
              color="primary"
            >
              Current
            </v-btn>
            <v-btn
              v-else-if="
                internal && subscription.indexOf('commercial_custom_') < 0
              "
              :to="{
                name: 'update-plan',
                params: { plan: 'commercial_shared' }
              }"
              color="primary"
            >
              Select
            </v-btn>
            <v-btn v-else-if="!internal" color="primary" @click="signup">
              Sign up
            </v-btn>
          </th>
          <th>
            COMMERCIAL CUSTOM
            <span class="price">
              Custom
            </span>
            <v-btn
              v-if="
                internal && subscription.indexOf('commercial_custom_') === 0
              "
              disabled
              color="primary"
            >
              Current
            </v-btn>
            <v-btn v-else color="primary" to="/contact">
              Contact Us
            </v-btn>
          </th>
          <th>
            ENTERPRISE (Mosaic Situation Viewer)
            <span class="price">
              Custom
            </span>
            <v-btn color="primary" to="/contact">
              Contact Us
            </v-btn>
          </th>
        </tr>
        <template v-for="featureGroup in dataBlockFeatures">
          <tr
            v-if="featureGroup.blockTitle !== false"
            :key="featureGroup.blockTitle"
          >
            <td class="bold dark">
              {{ featureGroup.blockTitle }}
            </td>
            <td class="dark"></td>
            <td class="dark"></td>
            <td class="dark"></td>
            <td class="dark"></td>
            <td class="dark"></td>
            <td class="dark"></td>
            <td class="dark"></td>
          </tr>
          <tr
            v-for="(feature, row) in featureGroup.items"
            :key="feature.feature"
          >
            <td :class="row % 2 !== 0 ? 'odd' : ''" v-html="feature.feature" />
            <td
              v-for="(enabled, k) in feature.enabled"
              :key="k"
              :class="row % 2 !== 0 ? 'odd' : ''"
            >
              <v-icon
                v-if="enabled && typeof enabled === 'boolean'"
                x-small
                color="red"
              >
                fas fa-check
              </v-icon>
              <span v-else-if="typeof enabled === 'string'" v-html="enabled" />
            </td>
          </tr>
        </template>
      </table>
    </v-row>
    <ConfirmDialog
      :display="showCancel"
      :ok-loading="cancelingSubscription"
      @ok="cancel"
      @cancel="showCancel = false"
    >
      <template slot="title">
        Cancel Subscription?
      </template>
      <template slot="body">
        This will cancel your subscription at the end of this billing period.
        Are you sure?
      </template>
    </ConfirmDialog>
  </v-container>
</template>
<style scoped lang="scss">
$tableBoarder: rgba(155, 155, 155, 0.3) 0.5px solid;

.pricing-table {
  max-width: 1280px;
  background: white;
  border: $tableBoarder;
  margin-bottom: 100px;
  border-spacing: 0;
}

.pricing-table th {
  border-top: $tableBoarder;
  border-right: $tableBoarder;
  border-left: $tableBoarder;
  vertical-align: bottom;
}

.pricing-table td {
  padding: 10px 10px;
  text-align: center;
  border-top: $tableBoarder;
  border-right: $tableBoarder;
  border-left: $tableBoarder;
}

.pricing-table th {
  padding: 50px 0;
}

.pricing-table-title {
  text-align: center;
  letter-spacing: 0;
  color: #525252;
  opacity: 1;
}

.odd {
  background-color: #5252520d;
}

.dark {
  background-color: #5252522f;
}

.price {
  margin: 20px 0 20px 0;
  font-family: NunitoSanBold, serif;
  font-weight: bold;
  color: #db3539;
  display: block;
  font-size: 25px;
}
.price span {
  margin-left: -5px;
  font-size: 12px;
  color: #c7c7c7;
}
.bold {
  font-weight: bold;
}

@media (max-width: 1280px) {
  .pricing-table {
    max-width: 960px;
  }
}
</style>
<script>
import { mapGetters } from 'vuex'
import { EventBus, Events } from '../../lib/Eventbus'
import { constants } from '@/lib/Constants'
import UsesUpdateSubscription from '@/mixins/UsesUpdateSubscription'
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    ConfirmDialog
  },
  mixins: [UsesUpdateSubscription],
  props: {
    internal: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data: () => ({
    freePlan: constants.subscriptions.free,
    showCancel: false,
    cancelingSubscription: false
  }),
  computed: {
    ...mapGetters({
      activeSubscription: 'user/getActiveSubscription'
    }),
    dataBlockFeatures() {
      return constants.dataBlockFeatures
    },
    subscription() {
      if (this.activeSubscription.id) {
        return this.activeSubscription.plan.nickname
          .toLowerCase()
          .replaceAll(' ', '_')
      }
      return ''
    }
  },
  methods: {
    signup() {
      EventBus.$emit(Events.navigation.openSignupDialog)
    },
    cancel() {
      this.cancelingSubscription = true
      this.updateSubscription(this.freePlan)
    }
  }
}
</script>
